import tradeException from './index';

export default {
    path: '/home/trade/exception',
    component: tradeException
}